export enum EnumProductType {
    consortium = 1,
    bank = 2,
    insurance = 3,
}
